import { graphql } from 'react-relay';
export const LoomAuthTokenQuery = graphql`
	query LoomAuthTokenQuery {
		loomToken {
			token
		}
	}
`;
